export function whereLikeInput(param: string | undefined) {
  if (param && param.length > 0) {
    let ret = param.replaceAll('%', '').trim();
    ret = `%${ret}%`;
    return ret;
  }
}
